import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { resolveRoleLanding } from '../hooks/useRoleLanding';

interface PortalBoundaryProps {
  roleCode: string;
  children: React.ReactNode;
}

/**
 * Backstop at the protected-route boundary. OrgGate reconciles the first
 * post-login destination; this component also covers direct URLs, browser
 * history, bookmarks, and notification deep links during an active session.
 */
const PortalBoundary: React.FC<PortalBoundaryProps> = ({ roleCode, children }) => {
  const location = useLocation();
  const intended = `${location.pathname}${location.search}${location.hash}`;
  const resolved = resolveRoleLanding(roleCode, intended);

  if (resolved !== intended) {
    return <Navigate to={resolved} replace />;
  }
  return <>{children}</>;
};

export default PortalBoundary;
